import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "allSetPage" };
const _hoisted_2 = { class: "anchor-bottom" };
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
/* When the last CSS animation below finishes (badgeBottom: 1.9s delay + 0.4s) */
const READY_MS = 2300;
export default /*@__PURE__*/ _defineComponent({
    __name: 'SignInAllSetPage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const ready = ref(false);
        let timer = null;
        onMounted(() => {
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            timer = setTimeout(() => { ready.value = true; }, reducedMotion ? 0 : READY_MS);
        });
        onBeforeUnmount(() => {
            if (timer)
                clearTimeout(timer);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: 0,
                    transparent: true
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createStaticVNode("<svg class=\"allSetGraphic\" viewBox=\"0 0 136 136\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" data-v-263ede10><defs data-v-263ede10><linearGradient id=\"allSetRingGradient\" x1=\"68\" y1=\"0\" x2=\"68\" y2=\"136\" gradientUnits=\"userSpaceOnUse\" data-v-263ede10><stop class=\"ringTop\" data-v-263ede10></stop><stop class=\"ringBottom\" offset=\"1\" data-v-263ede10></stop></linearGradient><linearGradient id=\"allSetBadgeGradient\" x1=\"68\" y1=\"36\" x2=\"68\" y2=\"84\" gradientUnits=\"userSpaceOnUse\" data-v-263ede10><stop class=\"badgeTop\" data-v-263ede10></stop><stop class=\"badgeBottom\" offset=\"1\" data-v-263ede10></stop></linearGradient></defs><circle class=\"ringTrack\" cx=\"68\" cy=\"68\" r=\"64\" stroke-width=\"8\" data-v-263ede10></circle><circle class=\"ringArc\" cx=\"68\" cy=\"68\" r=\"64\" stroke=\"url(#allSetRingGradient)\" stroke-width=\"8\" stroke-linecap=\"round\" transform=\"rotate(-90 68 68)\" data-v-263ede10></circle><g class=\"badge\" data-v-263ede10><circle cx=\"68\" cy=\"60\" r=\"24\" fill=\"url(#allSetBadgeGradient)\" data-v-263ede10></circle><path class=\"badgeTick\" transform=\"translate(44 36)\" d=\"M31.8701 15.3236C32.4126 14.6978 33.3594 14.6299 33.9853 15.1722C34.6108 15.7149 34.6791 16.6626 34.1367 17.2884L21.4853 31.8822L20.3476 33.1947L19.2148 31.8773L13.8623 25.6507C13.3224 25.0225 13.3942 24.0755 14.0224 23.5355C14.6506 22.9956 15.5977 23.0666 16.1377 23.6947L20.3574 28.6029L31.8701 15.3236Z\" data-v-263ede10></path></g><rect class=\"badgeBar\" x=\"44\" y=\"92\" width=\"48\" height=\"6\" rx=\"3\" data-v-263ede10></rect></svg><div class=\"allSetCopy\" data-v-263ede10><h1 data-v-263ede10>You&#39;re all set</h1><p data-v-263ede10>Find some helpful next steps on your homepage.</p></div>", 2)),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(MGButton, {
                            text: "Jump in",
                            neutral: true,
                            arrow: true,
                            fullWidth: true,
                            disabled: !ready.value,
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).replace({ path: '/' })))
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
